import { useEffect, useState } from "react";

/** Signal generation time + live freshness age — helps a late viewer decide
 *  whether the entry is still worth taking. Re-ticks every 30s. */
export const SignalAge = ({ generatedAt }) => {
  const [, setTick] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setTick((t) => t + 1), 30_000);
    return () => clearInterval(id);
  }, []);
  if (!generatedAt) return null;
  const mins = Math.max(0, Math.round((Date.now() - new Date(generatedAt).getTime()) / 60000));
  const tone = mins <= 15
    ? { text: "text-[#22C55E]", border: "border-[#22C55E]/40", label: "FRESH" }
    : mins <= 45
      ? { text: "text-[#F59E0B]", border: "border-[#F59E0B]/40", label: "AGING" }
      : { text: "text-[#EF4444]", border: "border-[#EF4444]/40", label: "LATE ENTRY RISK" };
  const timeStr = new Date(generatedAt).toLocaleString("en-IN", {
    day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit",
  });
  return (
    <div className={`flex items-center justify-between border ${tone.border} bg-[#121212] px-3 py-2`} data-testid="ew-signal-age">
      <div className="text-[10px] font-mono uppercase tracking-widest text-zinc-500">
        Signal time · <span className="text-zinc-300">{timeStr}</span>
      </div>
      <div className={`text-[10px] font-mono uppercase tracking-widest font-bold ${tone.text}`} data-testid="ew-signal-age-badge"
           title={mins > 45 ? "Price may have moved far from the entry level — verify before entering." : mins > 15 ? "Setup is aging — check price vs entry before taking it." : "Setup generated recently."}>
        {mins <= 1 ? "JUST NOW" : `${mins} MIN AGO`} · {tone.label}
      </div>
    </div>
  );
};
